export default "__VITE_ASSET__BQsIInnY__"